const defaultState = {};

const mutations = {
    setNetworkState(state, network) {
        Object.assign(state, network);
    },
    resetNetworkState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getNetworkInfo({ commit, dispatch }, networkId) {
        try {
            const { data } = await this.$rq.getNetworkInfo(networkId);
            commit('setNetworkState', data);
        } catch (err) {
            dispatch('resetNetworkInfo');
        }
    },
    resetNetworkInfo({ commit }) {
        commit('resetNetworkState');
    },
};

const getters = {
    network: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
